export const sortByProperty = (property, reverse) => {
    let reverseModifier = (reverse) ? -1 : 1;

    return function (a,b) {
        if (a[property] === b[property]) {
            return 0;
        }
        else if (a[property] === null) {
            return 1 * reverseModifier;
        }
        else if (b[property] === null) {
            return -1 * reverseModifier;
        }
        else {
            return a[property] < b[property] ? (-1 * reverseModifier) : (1 * reverseModifier);
        }
    }
}